import React from "react";

export default function DashboardApp() {
  return (
    <div className="bg-slate-100 dark:bg-gray-800 min-h-screen pb-8">
      <div className="max-w-7xl mx-auto">
        <div className="p-8">
          <div className="flex justify-center">
            <div className="flex flex-col max-w-full">
              <div className="align-middle inliner-block max-w-full overflow-auto">
                <div className="flex justify-between mb-8 flex-wrap"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
